import theme from '../../themes/green';

const styles = {
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  label: {
    color: theme.pallete.lightTextColor,
    fontSize: 12,
    fontWeight: '600',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/EditableLabel/styles.js